import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import dateFormat from "dateformat";
import moment from "moment";
import TextField from "@mui/material/TextField";
import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import InfoIcon from "@mui/icons-material/Info";
import IconButton from "@mui/material/IconButton";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  CardHeader,
  CardContent,
  Checkbox,
  Grid,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Button,
  Chip,
} from "@mui/material";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import Marquee from "react-fast-marquee";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

const duration = 2;
const InprogressState = (props) => {
  const { executionStatus, remedyDate } = props;

  const datecheck = new Date(remedyDate);
  const day = datecheck.getDate();
  const month = datecheck.getMonth() + 1;
  const year = datecheck.getFullYear();
  const hours = datecheck.getHours();
  const minutes = datecheck.getMinutes();

  const finalDate = `${year}-${month}-${day}`;

  const cnow = new Date();
  const currentday = cnow.getDate();
  const currnetmonth = cnow.getMonth() + 1;
  const currentyear = cnow.getFullYear();
  const currnethours = cnow.getHours();
  const currentminutes = cnow.getMinutes();

  const currentDate = `${currentyear}-${currnetmonth}-${currentday}`;

  var dt = moment(datecheck, ["h:mm A"]).format("HH:mm A");
  const [hours1, minutes1] = dt.split(":");
  const extraTime = parseInt(duration) + parseInt(hours1);

  var show;
  if (currentDate === finalDate) {
    if (extraTime <= 24) {
      if (currnethours <= extraTime) {
        show = true;
      } else {
        show = false;
      }
    } else {
      const newvalue = extraTime - 24;
      if (currnethours === newvalue) {
        show = true;
      } else {
        show = false;
      }
    }
  } else {
    show = false;
  }
  return show ? (
    <React.Fragment>
      <Brightness1Icon style={{ fontSize: "8px", color: "lightgray" }} />
      <span> {executionStatus}</span>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Brightness1Icon style={{ fontSize: "8px", color: "gold" }} />
      <span> Time-out</span>
    </React.Fragment>
  );
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function Credentials() {
  const [selectedCustomerIds, setSelectedCustomerIds] = useState([]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [searchitems, setSearchItems] = React.useState(0);

  const [remedylist, setRemedylist] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/run_remedy_output`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + window.localStorage.getItem("token"),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (data.detail) {
          window.localStorage.setItem("user_access", data.detail);
        } else {
          setRemedylist(data);
        }
      })
      .catch((error) => {
        console.error(error);
        window.location.href = "/something_went_wrong";
      });
  }, []);

  const handleLimitChange = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const [open, setOpen] = useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };

  const [open2, setOpen2] = useState(false);
  const [focusAfterClose2] = useState(true);
  const toggle2 = () => setOpen2(!open2);

  const handleClose = () => {
    setOpen(false);
  };
  const toggle = () => setOpen(!open);

  function refreshPage() {
    window.location.reload();
  }

  const unique = [
    ...new Set(
      remedylist.sort((a, b) => (a.serial_number > b.serial_number ? -1 : 1))
    ),
  ];

  const [one, setone] = React.useState(false);

  const oneopen = () => {
    setone(true);
  };

  const oneClose = () => {
    setone(false);
  };

  const cloumnName = "name";
  return (
    <>
      <form className="md:flex hidden flex-row flex-wrap items-center lg:ml-auto mr-3">
        <div className="relative flex flex-wrap items-stretch">
          <span className="z-10 h-full leading-snug font-normal absolute text-center text-blueGray-300 absolute bg-transparent rounded text-base items-center justify-center w-8 pl-3 py-3">
            <i className="fas fa-search"></i>
          </span>
          <input
            type="text"
            placeholder="Search Hostname here..."
            onChange={(event) => {
              console.log(event.target.value);
              setSearchItems(event.target.value);
            }}
            className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 relative bg-white bg-white rounded text-sm shadow outline-none focus:outline-none focus:ring w-full pl-10"
          />
        </div>
      </form>
      <br />
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
        <Card>
          <CardHeader title="REMEDY LIST" />
          <Paper sx={{ width: "100%" }}>
            <TableContainer sx={{ maxHeight: 1050 }}>
              <Table>
                <TableHead className="bg-lightBlue-200">
                  <TableRow>
                    <TableCell>Remedy ID</TableCell>
                    <TableCell>Host</TableCell>
                    <TableCell>Execution status</TableCell>
                    <TableCell>Execution On</TableCell>
                    <TableCell>Logs</TableCell>
                    <TableCell>Details</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {unique
                    .slice(page * limit, page * limit + limit)
                    .filter((val) => {
                      if (searchitems == "") {
                        return val;
                      } else if (
                        val[cloumnName]
                          .toLowerCase()
                          .includes(searchitems.toLowerCase())
                      ) {
                        return val;
                      }
                    })
                    .map((remedy) => (
                      <TableRow
                        hover
                        key={remedy.id}
                        selected={selectedCustomerIds.indexOf(remedy.id) !== -1}
                      >
                        <TableCell>
                          <Box
                            sx={{
                              alignItems: "center",
                              display: "flex",
                            }}
                          >
                            <Typography color="textPrimary" variant="body1">
                              {remedy.serial_number}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>{remedy.name}</TableCell>
                        <TableCell>
                          {remedy.execution_status === "Succeeded" ? (
                            <React.Fragment>
                              <Brightness1Icon
                                style={{
                                  fontSize: "8px",
                                  color: "greenyellow",
                                }}
                              />
                              <span> Succeeded</span>
                            </React.Fragment>
                          ) : remedy.execution_status === "Failed" ? (
                            <React.Fragment>
                              <Brightness1Icon
                                style={{
                                  fontSize: "8px",
                                  color: "palevioletred",
                                }}
                              />
                              <span> {remedy.execution_status}</span>
                            </React.Fragment>
                          ) : remedy.execution_status === "In Progress" ? (
                            <InprogressState
                              executionStatus={remedy.execution_status}
                              remedyDate={remedy.remedy_date}
                            />
                          ) : (
                            ""
                          )}
                        </TableCell>
                        <TableCell>
                          {dateFormat(
                            remedy.remedy_date,
                            "mmmm dS, yyyy h:MM TT "
                          )}
                          (IST)
                        </TableCell>
                        <TableCell>
                          <IconButton
                            title="Log"
                            aria-label="log"
                            id="log"
                            style={{
                              padding: "0px",
                              color: "#dca43e",
                              marginTop: "-4px",
                            }}
                          >
                            <Link
                              to={{
                                pathname: "/admin/remedylog",
                              }}
                              onClick={() => {
                                window.sessionStorage.setItem(
                                  "hostID",
                                  remedy.host
                                );
                                window.sessionStorage.setItem(
                                  "remedyID",
                                  remedy.id
                                );
                                window.sessionStorage.setItem(
                                  "OS",
                                  remedy.platform
                                );
                              }}
                            >
                              <InsertDriveFileIcon
                                fontSize="small"
                                style={{ color: "#1ab1e8" }}
                              />
                            </Link>
                          </IconButton>
                        </TableCell>
                        <TableCell>
                          {remedy.execution_status === "Succeeded" ? (
                            <button
                              className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                              type="button"
                            >
                              <Link
                                to={{
                                  pathname: "/admin/remedydetailedview",
                                }}
                                onClick={() => {
                                  window.sessionStorage.setItem(
                                    "hostID",
                                    remedy.host
                                  );
                                  window.sessionStorage.setItem(
                                    "remedyID",
                                    remedy.id
                                  );
                                  window.sessionStorage.setItem(
                                    "OS",
                                    remedy.platform
                                  );
                                }}
                                style={{ color: "#FFF" }}
                              >
                                Details
                              </Link>
                            </button>
                          ) : remedy.execution_status === "Failed" ? (
                            <button
                              className="bg-red-500 text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                              type="button"
                            >
                              <Link
                                to={{
                                  pathname: "/admin/remedylog",
                                }}
                                onClick={() => {
                                  window.sessionStorage.setItem(
                                    "hostID",
                                    remedy.host
                                  );
                                  window.sessionStorage.setItem(
                                    "remedyID",
                                    remedy.id
                                  );
                                  window.sessionStorage.setItem(
                                    "OS",
                                    remedy.platform
                                  );
                                }}
                                style={{ color: "#FFF" }}
                              >
                                Error
                              </Link>
                            </button>
                          ) : (
                            <button
                              className="bg-blueGray-200 text-white active:bg-lightBlue-600 font-bold text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                              type="button"
                              disabled="true"
                            >
                              Details
                            </button>
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          <TablePagination
            component="div"
            count={remedylist.length}
            onPageChange={handlePageChange}
            onRowsPerPageChange={handleLimitChange}
            page={page}
            rowsPerPage={limit}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Card>
      </div>
    </>
  );
}